import { ArrowLeft, ShieldCheck } from "lucide-react";
import { Link } from "react-router-dom";

const statusLabels = {
  connecting: "Connecting",
  connected: "Connected",
  unavailable: "Unavailable",
};

export const ChatHeader = ({ status }) => (
  <header className="chat-header" data-testid="chat-header">
    <div className="chat-header__inner">
      <Link
        to="/"
        className="chat-header__back"
        aria-label="Back to Supple"
        data-testid="chat-back-home-link"
      >
        <ArrowLeft aria-hidden="true" />
      </Link>

      <div className="chat-header__brand">
        <span className="chat-header__mark" aria-hidden="true">
          <ShieldCheck />
        </span>
        <div className="chat-header__copy">
          <h1 data-testid="chatbot-title">SuppleAI Perimenopause Chatbot</h1>
          <p data-testid="chatbot-subtitle">
            Every answer cited <span aria-hidden="true">·</span> clinical sources only
          </p>
        </div>
      </div>

      <div
        className={`chat-status chat-status--${status}`}
        data-testid="chat-connection-status"
      >
        <span aria-hidden="true" />
        <span>{statusLabels[status]}</span>
      </div>
    </div>
  </header>
);